module.exports = __webpack_public_path__ + "img/The-Jakarta-Post-967x683-09.57d8935d.jpg";